
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class RainStreaksEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const speed = (1 + layerIndex) * 500 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        
        for (let x = x1; x <= x2; x += spacing / 2) {
            const driftP = this.pseudoRandom(x);
            const offset = (time * speed * (0.8 + driftP * 0.4)) % spacing;
            
            for (let y = y1; y <= y2; y += spacing) {
                const len = (15 + driftP * 25) * scale;
                
                const draw = () => {
                    ctx.beginPath();
                    ctx.lineWidth = (1 / layerIndex) * scale;
                    ctx.moveTo(x, y + offset);
                    ctx.lineTo(x, y + offset + len);
                    ctx.stroke();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
